import { render, staticRenderFns } from "./MenuTopbar.vue?vue&type=template&id=71792c99"
import script from "./MenuTopbar.vue?vue&type=script&lang=js"
export * from "./MenuTopbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports